import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import axios from "axios";
import config from "../config";
import PageBanner from "./banner";
import PatientLogoutButton from "./PatientLogoutButton";

const PatientLayout = () => {
  const patientID = localStorage.getItem("patientID");

  const [groupName, setGroupName] = useState("");
  const [loading, setLoading] = useState(true);

  const isLoggedIn = !!patientID;

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const res = await axios.get(
          `${config.API_BASE_URL}/patient/group/${patientID}`
        );
        setGroupName(res.data.groupName);
      } catch {
        setGroupName("Your Care Group");
      } finally {
        setLoading(false);
      }
    };

    if (patientID) fetchGroup();
  }, [patientID]);

  if (!isLoggedIn) return null;

  return (
    <>
      <PageBanner
        title="User Family Circle"
        subtitle=""
        rightContent={isLoggedIn && <PatientLogoutButton />}
      />

      {!loading && (
        <div style={groupBadge}>
          You are part of <strong>{groupName}</strong>
        </div>
      )}

      <Outlet />
    </>
  );
};

export default PatientLayout;

const groupBadge = {
  padding: "10px 40px",
  background: "#eef5ff",
  color: "#0E5580",
  fontSize: "15px"
};
